import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  get_order_list,
  get_dp_vehicle_list,
  get_vehicle_driver_list,
} from "../../redux/orderSlice";
import { get_dp_list } from "../../redux/dplistSlice";
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiPhone,
  FiSearch,
} from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDataCard from "../../components/CustomDataCard";
import { baseUrl, formatCurrency } from "../../utils/utils";
import { useToast } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Spinner,
} from "@chakra-ui/react";
import GasCylinderLoader from "../../components/GasCylinderLoader";
import { calculateGrandTotal } from "./customerProductDetail";
import VehicleOrderMap from "./VehicleOrderMap";

const buttonOptions = [
  { label: "Recieved", value: "1", color: "#38A169", colorScheme: "green" },
  { label: "Initiated", value: "2", color: "#ED8936", colorScheme: "orange" },
  { label: "Dispatched", value: "3", color: "#9F7AEA", colorScheme: "purple" },
  { label: "Delivered", value: "4", color: "#4299E1", colorScheme: "blue" },
  { label: "Canceled", value: "5", color: "#FF0000", colorScheme: "red" },
  {
    label: "Rescheduled Orders",
    value: "6",
    color: "#FFC0CB",
    colorScheme: "pink",
  },
  {
    label: "Live Tracking",
    value: "7",
    color: "#2d75a5",
    colorScheme: "blue",
  },
];

const Orders = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const num = location.state?.type;
  const toast = useToast();

  const { order_list, total_order_count, report_url, loading } = useSelector(
    (state) => state.orders,
  );

  const {
    dp_vehicle_list,
    vehicle_driver_list,
    vehicle_loading,
    driver_loading,
  } = useSelector((state) => state.orders);

  const { dp_list } = useSelector((state) => state.dplist);
  const dispatch = useDispatch();

  const [pincodeOrders, setPincodeOrders] = useState([]);
  const [page, setpage] = useState(
    () => Number(location.state?.returnPage) || 1,
  );
  const [rows, setRows] = useState(
    () => Number(location.state?.returnRows) || 5,
  );
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);

  const [assignModalData, setAssignModalData] = useState({
    dplist: "",
    vehicle: "",
    driver: "",
    dplist_error: "",
    vehicle_error: "",
    driver_error: "",
  });

  // New state for pincode assignment modal
  const [isOpenPincodeModal, setIsOpenPincodeModal] = useState(false);
  const [availablePincodes, setAvailablePincodes] = useState([]);
  const [pincodeFilters, setPincodeFilters] = useState({
    pincode: "",
    scheduleDate: "",
    scheduleTime: "",
  });
  const [loadingPincodes, setLoadingPincodes] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);

  const [assignLoading, setAssignLoading] = useState(false);

  const total = Number(total_order_count) || 0;
  const pageNum = Number(page) || 1;
  const rowsNum = Number(rows) || 5;

  const startIndex = total === 0 ? 0 : (pageNum - 1) * rowsNum + 1;
  const endIndex = Math.min(pageNum * rowsNum, total);

  const [type, setType] = useState(() => {
    return location.state?.returnType || "1";
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  console.log(filteredOrders, "thisismap");
  useEffect(() => {
    fetchTimeSlots();
  }, []);

  const fetchTimeSlots = async () => {
    try {
      const body = new FormData();
      body.append("action", "list");

      const res = await fetch(
        "https://gaswale.vensframe.com/api/customer/completelist.php",
        {
          method: "POST",
          body: body,
        },
      );

      const data = await res.json();

      const slots = data?.data?.reponselist?.time_slots || [];
      setTimeSlots(slots);
    } catch (error) {
      console.log("Error fetching time slots:", error);
    }
  };

  useEffect(() => {
    if (location.state?.returnType) {
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    store.dispatch(get_order_list({ page: page, rows: rows, type }));
  }, [type]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredOrders(order_list);
    } else {
      const lower = searchTerm.toLowerCase();
      const filtered = order_list.filter(
        (order) =>
          order.customer_name?.toLowerCase().includes(lower) ||
          order.customer_business_name?.toLowerCase().includes(lower) ||
          order.orderid?.toString().toLowerCase().includes(lower) ||
          order.mobile?.toLowerCase().includes(lower),
      );
      setFilteredOrders(filtered);
    }
  }, [searchTerm, order_list]);

  const onPrevious = () => {
    if (pageNum === 1) return;
    const newPage = pageNum - 1;
    setpage(newPage);
    store.dispatch(get_order_list({ page: newPage, rows: rowsNum, type }));
  };

  const onNext = () => {
    if (rowsNum * pageNum >= total) return;
    const newPage = pageNum + 1;
    setpage(newPage);
    store.dispatch(get_order_list({ page: newPage, rows: rowsNum, type }));
  };
  const createCustomerCardData = (customer) => {
    const truncateText = (text, maxLength = 50) => {
      if (!text) return "Not provided";
      return text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text;
    };

    // Calculate grand total using the same logic as order details
    const grandTotal = calculateGrandTotal(
      customer.details || [],
      type,
      customer.paymentmode,
    );

    const baseData = [
      { key: "Customer Name", value: customer.customer_name },
      { key: "Business Name", value: customer.customer_business_name },
      { key: "Order ID", value: customer.orderid, iconColor: "green.500" },
      {
        key: "Mobile Number",
        value: customer.mobile,
        icon: FiPhone,
        iconColor: "green.500",
      },
      {
        key: "Total Amount",
        value: formatCurrency(grandTotal), // Use calculated grand total
      },
      { key: "Payment Mode", value: customer.paymentmode },
      ...(customer.paymentmode === "PO"
        ? [{ key: "PO Number", value: customer.ponum }]
        : []),
      { key: "Ordered Date", value: customer.datetime },
      {
        key: "Shipping Address",
        value: (
          <Tooltip
            label={customer.shipping_address || "Not provided"}
            placement="top"
            hasArrow
          >
            <Text cursor="pointer" _hover={{ color: "blue.500" }}>
              {truncateText(customer.shipping_address, 40)}
            </Text>
          </Tooltip>
        ),
      },
    ];

    if (type === "4") {
      return [...baseData, { key: "Invoice no.", value: customer.inv_no }];
    }

    if (type === "1" || type === "2") {
      return [
        ...baseData,
        { key: "Scheduled Date", value: customer.scheduledate },
        { key: "Scheduled Time", value: customer.scheduletime },
      ];
    }

    return baseData;
  };

  const downloadExcel = async () => {
    try {
      const response = await fetch(report_url, { method: "GET" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Order_Report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  };

  useEffect(() => {
    store.dispatch(get_dp_list({ page: 1, rows: 100 }));
  }, [dispatch]);

  useEffect(() => {
    if (assignModalData.dplist) {
      dispatch(get_dp_vehicle_list(assignModalData.dplist));
    }
  }, [assignModalData.dplist, dispatch]);

  useEffect(() => {
    if (assignModalData.vehicle) {
      dispatch(get_vehicle_driver_list(assignModalData.vehicle));
    }
  }, [assignModalData.vehicle, dispatch]);

  // Fetch available pincodes when modal opens
  const fetchAvailablePincodes = async () => {
    setLoadingPincodes(true);
    try {
      const body = new FormData();
      body.append("action", "order_by_pincode");
      body.append("pincode", ""); // Empty to get all
      body.append("type", type);
      body.append("page", "1");
      body.append("limit", "1000"); // Get more records to extract all pincodes

      const response = await fetch(baseUrl + "orders.php", {
        method: "POST",
        body: body,
      });
      const data = await response.json();

      if (data.success && data.reponselist) {
        // Extract unique pincodes from the response
        const pincodes = [
          ...new Set(
            data.reponselist.map((order) => order.pincode).filter(Boolean),
          ),
        ];
        setAvailablePincodes(pincodes.sort());
      } else {
        setAvailablePincodes([]);
      }
    } catch (error) {
      console.error("Error fetching pincodes:", error);
      setAvailablePincodes([]);
    } finally {
      setLoadingPincodes(false);
    }
  };

  const handleApplyPincodeFilters = async () => {
    if (!pincodeFilters.pincode) {
      toast({
        title: "Missing Field",
        description: "Please select a pincode",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    // if (!pincodeFilters.scheduleDate) {
    //   toast({
    //     title: "Missing Field",
    //     description: "Please select a schedule date",
    //     status: "warning",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }
    // if (!pincodeFilters.scheduleTime) {
    //   toast({
    //     title: "Missing Field",
    //     description: "Please select a schedule time",
    //     status: "warning",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }

    setLoadingOrders(true);
    try {
      const body = new FormData();
      body.append("action", "order_by_pincode");
      body.append("pincode", pincodeFilters.pincode);
      body.append("type", type);
      body.append("page", "1");
      body.append("limit", "100");

      const response = await fetch(baseUrl + "orders.php", {
        method: "POST",
        body,
      });
      const data = await response.json();

      if (data.success && data.reponselist) {
        let filtered = data.reponselist;

        if (pincodeFilters.scheduleDate || pincodeFilters.scheduleTime) {
          filtered = data.reponselist.filter((order) => {
            const dateMatch =
              !pincodeFilters.scheduleDate ||
              order.scheduledate === pincodeFilters.scheduleDate;

            // Normalize time by removing leading zeros from hours
            let timeMatch = true;
            if (pincodeFilters.scheduleTime) {
              const normalizeTime = (time) => {
                if (!time) return "";
                // Remove leading zeros: "07:00" -> "7:00", "01:00" -> "1:00"
                return time.replace(/\b0(\d)/g, "$1").trim();
              };
              timeMatch =
                normalizeTime(order.scheduletime) ===
                normalizeTime(pincodeFilters.scheduleTime);
            }

            return dateMatch && timeMatch;
          });
        }

        setPincodeOrders(filtered);
      } else {
        setPincodeOrders([]);
        toast({
          title: "No Orders Found",
          description: "No orders found for the selected criteria.",
          status: "info",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching pincode orders:", error);
      toast({
        title: "Error",
        description: "Failed to fetch orders. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      setPincodeOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  };

  const handleBulkAssignment = async () => {
    if (!assignModalData.dplist) {
      setAssignModalData({
        ...assignModalData,
        dplist_error: "Please select a delivery partner",
      });
      return;
    }
    if (!assignModalData.vehicle) {
      setAssignModalData({
        ...assignModalData,
        vehicle_error: "Please select a vehicle",
      });
      return;
    }
    if (!assignModalData.driver) {
      setAssignModalData({
        ...assignModalData,
        driver_error: "Please select a driver",
      });
      return;
    }

    setAssignLoading(true);

    try {
      const body = new FormData();
      body.append("action", "assign_order_by_pincode");

      let orderUserId = "1";

      selectedOrders.forEach((orderId) => {
        const order = pincodeOrders.find((o) => o.id === orderId);
        if (order) {
          if (!orderUserId || orderUserId === "1") {
            orderUserId = order.userid || "1";
          }

          if (order.details?.length) {
            order.details.forEach((detail) => {
              if (detail.id) {
                body.append("orderid[]", order.orderid);
                body.append("id[]", detail.id);
              }
            });
          } else {
            body.append("orderid[]", order.orderid);
            body.append("id[]", order.id);
          }
        }
      });

      body.append("userid", orderUserId);
      body.append("driver_id", assignModalData.driver);
      body.append("dpid", assignModalData.dplist);
      body.append("vehicle_id", assignModalData.vehicle);

      const firstOrder = pincodeOrders.find((o) =>
        selectedOrders.includes(o.id),
      );

      let scheduleTime;
      if (firstOrder?.scheduledate && firstOrder?.scheduletime) {
        const scheduleDate = firstOrder.scheduledate;
        const timeString = firstOrder.scheduletime;

        let startTime = timeString.includes(" to ")
          ? timeString.split(" to ")[0].trim()
          : timeString;

        const convertTo24Hour = (time12h) => {
          const [time, modifier] = time12h.split(" ");
          let [hours, minutes] = time.split(":");
          if (hours === "12") hours = "00";
          if (modifier === "PM") hours = parseInt(hours, 10) + 12;
          return `${hours.toString().padStart(2, "0")}:${minutes}:00`;
        };

        scheduleTime = `${scheduleDate} ${convertTo24Hour(startTime)}`;
      } else {
        scheduleTime = new Date().toISOString().slice(0, 19).replace("T", " ");
      }

      body.append("scheduletime", scheduleTime);

      const response = await fetch(baseUrl + "orders.php", {
        method: "POST",
        body: body,
      });

      const data = await response.json();

      if (data.success) {
        toast({
          title: "Success",
          description: "Orders assigned successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // ✅ Close popup after a short delay to ensure toast is visible
        setTimeout(() => {
          setIsOpenAssign(false);
          setIsOpenPincodeModal(false); // Also close the pincode modal
          setType("2"); // Switch to "Initiated" tab
          store.dispatch(get_order_list({ page: 1, rows: rowsNum, type: "2" })); // Fetch orders for type 2
        }, 500);

        setSelectedOrders([]);
        setAssignModalData({
          dplist: "",
          vehicle: "",
          driver: "",
          dplist_error: "",
          vehicle_error: "",
          driver_error: "",
        });
      } else {
        toast({
          title: "Assignment Failed",
          description: data.message || "Failed to assign orders",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error assigning orders:", error);
      toast({
        title: "Error",
        description: "Something went wrong while assigning orders.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setAssignLoading(false);
    }
  };

  const handleAutoAssign = async (id, auto_assign) => {
    try {
      const body = new FormData();
      body.append("action", "auto_assign");
      body.append("id", id);
      body.append("auto_assign", auto_assign);

      const response = await fetch(`${baseUrl}orders.php`, {
        method: "POST",
        body: body,
      });

      const data = await response.json();

      if (data.success) {
        store.dispatch(get_order_list({ page: page, rows: rows, type }));
        toast({
          title: "Success",
          description: data.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        console.log("Failed:", data.message);
        toast({
          title: "Error",
          description: data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error in auto assign:", error);
    }
  };

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexDir={{ base: "column", md: "row" }}
        gap={3}
        align={{ base: "start", md: "center" }}
      >
        <Heading fontSize="xl">Orders</Heading>

        <Spacer display={{ base: "none", md: "block" }} />

        {
          <Flex
            flexWrap="wrap"
            gap={3}
            w="full"
            justify={{ base: "flex-start", md: "flex-end" }}
            align="center"
          >
            <Select
              placeholder=""
              size="md"
              w={["100%", "80px"]}
              value={rows}
              onChange={(e) => {
                const newRows = Number(e.target.value);
                setRows(newRows);
                setpage(1);
                store.dispatch(
                  get_order_list({ page: 1, rows: newRows, type }),
                );
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>

            <InputGroup
              bg="#f4f5f7"
              borderRadius={5}
              w={{ base: "100%", sm: "auto" }}
              minW={{ sm: "200px" }}
              maxW="sm"
            >
              <Input
                placeholder="Search by name, business, order ID or phone..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <InputRightElement>
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            {report_url && (
              <Button
                colorScheme="blue"
                w={{ base: "100%", sm: "auto" }}
                minW="140px"
                onClick={downloadExcel}
              >
                Excel Download
              </Button>
            )}
          </Flex>
        }
      </Card>

      <Card p={4}>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={3}
        >
          <Wrap spacing={2}>
            {buttonOptions.map((btn) => (
              <WrapItem key={btn.value}>
                <Button
                  size="sm"
                  variant="outline"
                  colorScheme={btn.colorScheme}
                  onClick={() => {
                    setType(btn.value);
                    setpage(1);
                  }}
                  backgroundColor={type === btn.value ? btn.color + "60" : ""}
                  whiteSpace="normal"
                  textAlign="center"
                  height="auto"
                  py={2}
                >
                  {btn.label}
                </Button>
              </WrapItem>
            ))}
          </Wrap>

          {type === "1" && (
            <Button
              size="sm"
              colorScheme="blue"
              onClick={() => {
                setIsOpenPincodeModal(true);
                setPincodeOrders([]);
                setSelectedOrders([]);
                setPincodeFilters({
                  pincode: "",
                  scheduleDate: "",
                  scheduleTime: "",
                });
                fetchAvailablePincodes();
              }}
            >
              Pincode Assignment
            </Button>
          )}
        </Flex>
      </Card>

      {loading ? (
        <GasCylinderLoader size="sm" loadingText="Loading Orders" />
      ) : type == "7" ? (
        <VehicleOrderMap />
      ) : (
        <>
          <SimpleGrid minChildWidth="300px" spacing="10px">
            {filteredOrders?.map((el) => (
              <CustomDataCard
                key={el.id}
                isToggleShow={type == "1"}
                isOn={el?.auto_assign == "0" ? true : false}
                handleToggle={() => {
                  handleAutoAssign(el.id, el?.auto_assign == "0" ? "1" : "0");
                }}
                data={createCustomerCardData(el)}
                keyWidth="100px"
                keyColor="gray.700"
                keyWeight="medium"
                valueColor="gray.600"
                valueAlign="left"
                hoverEffect
                showButton
                buttonText={type !== "1" ? "View Details" : "Update Status"}
                onButtonClick={() => {
                  const orderData = {
                    orderid: el.orderid,
                    id: el.id,
                    type,
                    returnTo: "/orders",
                    returnType: type,
                    returnPage: page,
                    returnRows: rows,
                  };

                  navigate("/orders/order-detail", {
                    state: { orderData },
                  });

                  localStorage.setItem(
                    "lastOrderData",
                    JSON.stringify(orderData),
                  );
                }}
                shadow="lg"
              />
            ))}
          </SimpleGrid>

          <Card
            mt={3}
            p={3}
            flexWrap="wrap"
            gap={3}
            flexDir={{ base: "column", sm: "row" }}
            align="center"
            justify="center"
          >
            <FiChevronLeft
              cursor="pointer"
              color={page === 1 ? "gray" : "#007bc9"}
              size={30}
              onClick={onPrevious}
            />
            <Flex gap={2} align="center">
              <Text>{startIndex}</Text>
              <Text>-</Text>
              <Text>{endIndex}</Text>
              <Text>of</Text>
              <Text>{total}</Text>
            </Flex>
            <FiChevronRight
              cursor="pointer"
              color={rows * page >= total_order_count ? "gray" : "#007bc9"}
              size={30}
              onClick={onNext}
            />
          </Card>

          {/* Pincode Assignment Modal */}
          <Modal
            isOpen={isOpenPincodeModal}
            onClose={() => {
              setIsOpenPincodeModal(false);
              setPincodeOrders([]);
              setSelectedOrders([]);
            }}
            size="6xl"
            scrollBehavior="inside"
          >
            <ModalOverlay />
            <ModalContent maxH="90vh">
              <ModalHeader>Pincode Assignment</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {/* Filters Section */}
                <Card bg="#f8f9fa" p={4} mb={4}>
                  <Flex align="center" gap={2} mb={3}>
                    <FiSearch size={20} color="#718096" />
                    <Heading fontSize="lg" color="#2d3748">
                      Filter Orders
                    </Heading>
                  </Flex>

                  <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4}>
                    <FormControl>
                      <FormLabel fontSize="sm" fontWeight="600" color="#4a5568">
                        Pincode *
                      </FormLabel>
                      <Select
                        placeholder="Select Pincode"
                        value={pincodeFilters.pincode}
                        onChange={(e) =>
                          setPincodeFilters({
                            ...pincodeFilters,
                            pincode: e.target.value,
                          })
                        }
                        bg="white"
                        isDisabled={loadingPincodes}
                      >
                        {loadingPincodes ? (
                          <option>Loading pincodes...</option>
                        ) : (
                          availablePincodes.map((pincode) => (
                            <option key={pincode} value={pincode}>
                              {pincode}
                            </option>
                          ))
                        )}
                      </Select>
                    </FormControl>

                    <FormControl>
                      <FormLabel fontSize="sm" fontWeight="600" color="#4a5568">
                        Schedule Date *
                      </FormLabel>
                      <Input
                        type="date"
                        value={pincodeFilters.scheduleDate}
                        onChange={(e) =>
                          setPincodeFilters({
                            ...pincodeFilters,
                            scheduleDate: e.target.value,
                          })
                        }
                        bg="white"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel fontSize="sm" fontWeight="600" color="#4a5568">
                        Schedule Time *
                      </FormLabel>

                      <Select
                        placeholder="Select Time Slot"
                        value={pincodeFilters.scheduleTime}
                        onChange={(e) =>
                          setPincodeFilters({
                            ...pincodeFilters,
                            scheduleTime: e.target.value,
                          })
                        }
                        bg="white"
                      >
                        {timeSlots.map((slot) => (
                          <option key={slot.id} value={slot.value}>
                            {slot.label}
                          </option>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl>
                      <FormLabel
                        fontSize="sm"
                        fontWeight="600"
                        mb={2}
                        color="#4a5568"
                      >
                        Action
                      </FormLabel>
                      <Button
                        leftIcon={<FiSearch />}
                        colorScheme="blue"
                        w="full"
                        onClick={handleApplyPincodeFilters}
                        isLoading={loadingOrders}
                        loadingText="Loading..."
                      >
                        Apply Filters
                      </Button>
                    </FormControl>
                  </SimpleGrid>
                </Card>

                {/* Selection Actions */}
                {pincodeOrders.length > 0 && (
                  <Card p={3} mb={3} bg="blue.50">
                    <Flex
                      justify="space-between"
                      align="center"
                      flexWrap="wrap"
                      gap={3}
                    >
                      <HStack spacing={3}>
                        <Text fontWeight="600" fontSize="md">
                          {selectedOrders.length} order
                          {selectedOrders.length !== 1 ? "s" : ""} selected
                        </Text>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => {
                            if (
                              selectedOrders.length === pincodeOrders.length
                            ) {
                              setSelectedOrders([]);
                            } else {
                              setSelectedOrders(
                                pincodeOrders.map((order) => order.id),
                              );
                            }
                          }}
                        >
                          {selectedOrders.length === pincodeOrders.length
                            ? "Deselect All"
                            : "Select All"}
                        </Button>
                      </HStack>

                      <Button
                        leftIcon={<Text>🚚</Text>}
                        colorScheme="green"
                        size="md"
                        isDisabled={selectedOrders.length === 0}
                        onClick={() => {
                          setIsOpenAssign(true);
                          dispatch(get_dp_list());
                        }}
                      >
                        Assign to DP ({selectedOrders.length})
                      </Button>
                    </Flex>
                  </Card>
                )}

                {/* Orders Table */}
                {loadingOrders ? (
                  <Flex justify="center" align="center" py={10}>
                    <Spinner size="xl" color="blue.500" />
                    <Text ml={3}>Loading orders...</Text>
                  </Flex>
                ) : pincodeOrders.length > 0 ? (
                  <Card p={0} overflow="hidden">
                    <Box overflowX="auto">
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          minWidth: "800px",
                        }}
                      >
                        <thead style={{ backgroundColor: "#f7fafc" }}>
                          <tr>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={
                                  selectedOrders.length ===
                                    pincodeOrders.length &&
                                  pincodeOrders.length > 0
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedOrders(
                                      pincodeOrders.map((order) => order.id),
                                    );
                                  } else {
                                    setSelectedOrders([]);
                                  }
                                }}
                              />
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              ORDER ID
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              CUSTOMER
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              PINCODE
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              ADDRESS
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              SCHEDULE
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              PRODUCT
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              AMOUNT
                            </th>
                            <th
                              style={{
                                padding: "12px 16px",
                                textAlign: "left",
                                borderBottom: "2px solid #e2e8f0",
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#718096",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                              }}
                            >
                              STATUS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {pincodeOrders.map((order) => (
                            <tr
                              key={order.id}
                              style={{
                                borderBottom: "1px solid #e2e8f0",
                                transition: "background-color 0.2s",
                                backgroundColor: selectedOrders.includes(
                                  order.id,
                                )
                                  ? "#ebf8ff"
                                  : "white",
                              }}
                              onMouseEnter={(e) => {
                                if (!selectedOrders.includes(order.id)) {
                                  e.currentTarget.style.backgroundColor =
                                    "#f7fafc";
                                }
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  selectedOrders.includes(order.id)
                                    ? "#ebf8ff"
                                    : "white";
                              }}
                            >
                              <td style={{ padding: "16px" }}>
                                <input
                                  type="checkbox"
                                  checked={selectedOrders.includes(order.id)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedOrders([
                                        ...selectedOrders,
                                        order.id,
                                      ]);
                                    } else {
                                      setSelectedOrders(
                                        selectedOrders.filter(
                                          (id) => id !== order.id,
                                        ),
                                      );
                                    }
                                  }}
                                />
                              </td>
                              <td style={{ padding: "16px" }}>
                                <Text
                                  color="#3182ce"
                                  fontWeight="600"
                                  fontSize="14px"
                                >
                                  {order.orderid}
                                </Text>
                              </td>
                              <td style={{ padding: "16px" }}>
                                <Text
                                  fontWeight="600"
                                  fontSize="14px"
                                  color="#2d3748"
                                >
                                  {order.customer_name}
                                </Text>
                                <Text fontSize="13px" color="#718096" mt={1}>
                                  {order.mobile}
                                </Text>
                              </td>
                              <td style={{ padding: "16px" }}>
                                <span
                                  style={{
                                    backgroundColor: "#edf2f7",
                                    padding: "4px 12px",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    color: "#4a5568",
                                  }}
                                >
                                  {order.pincode}
                                </span>
                              </td>
                              <td
                                style={{ padding: "16px", maxWidth: "200px" }}
                              >
                                <Text
                                  fontSize="13px"
                                  color="#4a5568"
                                  noOfLines={2}
                                >
                                  {order.shipping_address}
                                </Text>
                              </td>
                              <td style={{ padding: "16px" }}>
                                <Text
                                  fontWeight="600"
                                  fontSize="14px"
                                  color="#2d3748"
                                >
                                  {order.scheduledate}
                                </Text>
                                <Text fontSize="13px" color="#718096" mt={1}>
                                  {order.scheduletime}
                                </Text>
                              </td>
                              <td style={{ padding: "16px" }}>
                                {order.details && order.details.length > 0 && (
                                  <>
                                    <Text
                                      fontSize="13px"
                                      color="#4a5568"
                                      mb={1}
                                    >
                                      {order.details[0].product_name}
                                    </Text>
                                    <span
                                      style={{
                                        backgroundColor: "#3182ce",
                                        color: "white",
                                        padding: "2px 10px",
                                        borderRadius: "12px",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Qty: {order.details[0].count}
                                    </span>
                                  </>
                                )}
                              </td>
                              <td style={{ padding: "16px" }}>
                                <Text
                                  color="#38a169"
                                  fontWeight="700"
                                  fontSize="15px"
                                >
                                  {formatCurrency(order.totalamount)}
                                </Text>
                              </td>
                              <td style={{ padding: "16px" }}>
                                <span
                                  style={{
                                    backgroundColor: "#fef5e7",
                                    color: "#d69e2e",
                                    padding: "6px 16px",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    display: "inline-block",
                                  }}
                                >
                                  {order.details && order.details.length > 0
                                    ? order.details[0].orderstatustext
                                    : "Pending"}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Box>
                  </Card>
                ) : (
                  <Flex
                    justify="center"
                    align="center"
                    py={10}
                    direction="column"
                    gap={3}
                  >
                    <Text fontSize="lg" color="#718096">
                      📦 No orders found
                    </Text>
                    <Text fontSize="sm" color="#a0aec0">
                      {pincodeFilters.pincode ||
                      pincodeFilters.scheduleDate ||
                      pincodeFilters.scheduleTime
                        ? "Try adjusting your filters"
                        : "Select filters above to search for orders"}
                    </Text>
                  </Flex>
                )}
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="gray"
                  onClick={() => {
                    setIsOpenPincodeModal(false);
                    setPincodeOrders([]);
                    setSelectedOrders([]);
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Assignment Modal */}
          <Modal
            isOpen={isOpenAssign}
            onClose={() => {
              setIsOpenAssign(false);
              setAssignModalData({
                dplist: "",
                vehicle: "",
                driver: "",
                dplist_error: "",
                vehicle_error: "",
                driver_error: "",
              });
            }}
            isCentered
            size="xl"
            scrollBehavior="inside"
          >
            <ModalOverlay />
            <ModalContent maxH="90vh">
              <ModalHeader>Assign Orders to Delivery Partner</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Flex flexDirection={"column"} gap={"2"} w={"full"}>
                  <FormControl
                    display={"flex"}
                    flexDirection={"column"}
                    gap={"2"}
                  >
                    {/* Delivery Partner Selection */}
                    <FormLabel mb={0} fontWeight={"bold"}>
                      Select Delivery Partner
                    </FormLabel>
                    <Select
                      value={assignModalData.dplist || ""}
                      onChange={(e) =>
                        setAssignModalData({
                          ...assignModalData,
                          dplist: e.target.value,
                          dplist_error: "",
                          vehicle: "",
                          driver: "",
                        })
                      }
                      placeholder="Select Delivery Partner"
                      size={"md"}
                      w={"full"}
                    >
                      {dp_list?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Select>
                    {assignModalData.dplist_error && (
                      <Text color={"red"} fontSize="sm">
                        {assignModalData.dplist_error}
                      </Text>
                    )}

                    {/* Vehicle Selection */}
                    <FormLabel mb={0} fontWeight={"bold"} mt={2}>
                      Select Vehicle
                    </FormLabel>
                    <Select
                      value={assignModalData.vehicle || ""}
                      onChange={(e) =>
                        setAssignModalData({
                          ...assignModalData,
                          vehicle: e.target.value,
                          vehicle_error: "",
                          driver: "",
                        })
                      }
                      placeholder="Select Vehicle"
                      size={"md"}
                      w={"full"}
                      disabled={!assignModalData.dplist}
                    >
                      {vehicle_loading ? (
                        <option disabled>Loading vehicles...</option>
                      ) : (
                        dp_vehicle_list?.map((item) => (
                          <option key={item.vehicle_id} value={item.vehicle_id}>
                            {item.vehicleno}
                          </option>
                        ))
                      )}
                    </Select>
                    {vehicle_loading && (
                      <Flex align="center" gap={2}>
                        <Spinner size="sm" />
                        <Text fontSize="sm">Loading vehicles...</Text>
                      </Flex>
                    )}
                    {assignModalData.vehicle_error && (
                      <Text color={"red"} fontSize="sm">
                        {assignModalData.vehicle_error}
                      </Text>
                    )}

                    {/* Driver Selection */}
                    <FormLabel mb={0} fontWeight={"bold"} mt={2}>
                      Select Driver
                    </FormLabel>
                    <Select
                      value={assignModalData.driver || ""}
                      onChange={(e) =>
                        setAssignModalData({
                          ...assignModalData,
                          driver: e.target.value,
                          driver_error: "",
                        })
                      }
                      placeholder="Select Driver"
                      size={"md"}
                      w={"full"}
                      disabled={!assignModalData.vehicle}
                    >
                      {driver_loading ? (
                        <option disabled>Loading drivers...</option>
                      ) : (
                        vehicle_driver_list?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      )}
                    </Select>
                    {driver_loading && (
                      <Flex align="center" gap={2}>
                        <Spinner size="sm" />
                        <Text fontSize="sm">Loading drivers...</Text>
                      </Flex>
                    )}
                    {assignModalData.driver_error && (
                      <Text color={"red"} fontSize="sm">
                        {assignModalData.driver_error}
                      </Text>
                    )}
                  </FormControl>
                </Flex>

                {/* Selected Orders Summary */}
                <Flex
                  mt={4}
                  p={3}
                  gap={3}
                  flexDirection={"column"}
                  bg={"#f8f9fa"}
                  w={"full"}
                  borderRadius={10}
                >
                  <Text fontSize={18} fontWeight={"bold"}>
                    Orders to Assign ({selectedOrders.length})
                  </Text>

                  <Box
                    maxH="300px"
                    overflowY="auto"
                    sx={{
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                      scrollBehavior: "smooth",
                    }}
                  >
                    {pincodeOrders
                      .filter((order) => selectedOrders.includes(order.id))
                      .map((order) => (
                        <Card key={order.id} p={3} mb={2} bg="white">
                          <Flex flexDirection="column" gap={2}>
                            <Flex justify="space-between" align="center">
                              <Text fontWeight="bold" color="#3182ce">
                                Order #{order.orderid}
                              </Text>
                              <Text fontWeight="bold" color="#38a169">
                                {formatCurrency(order.totalamount)}
                              </Text>
                            </Flex>

                            <Box>
                              <Text fontSize="sm" fontWeight="600">
                                {order.customer_name}
                              </Text>
                              <Text fontSize="sm" color="gray.600">
                                {order.mobile}
                              </Text>
                            </Box>

                            <Text fontSize="sm" color="gray.600" noOfLines={2}>
                              📍 {order.shipping_address}
                            </Text>

                            {order.details && order.details.length > 0 && (
                              <Box>
                                <Text fontSize="sm" fontWeight="600">
                                  Products:
                                </Text>
                                {order.details.map((detail, idx) => (
                                  <Text
                                    key={idx}
                                    fontSize="sm"
                                    color="gray.600"
                                  >
                                    • {detail.product_name} (Qty: {detail.count}
                                    )
                                  </Text>
                                ))}
                              </Box>
                            )}

                            <Flex gap={2} flexWrap="wrap">
                              <Box
                                bg="blue.50"
                                px={2}
                                py={1}
                                borderRadius="md"
                                fontSize="xs"
                              >
                                📅 {order.scheduledate}
                              </Box>
                              <Box
                                bg="blue.50"
                                px={2}
                                py={1}
                                borderRadius="md"
                                fontSize="xs"
                              >
                                🕐 {order.scheduletime}
                              </Box>
                              <Box
                                bg="gray.100"
                                px={2}
                                py={1}
                                borderRadius="md"
                                fontSize="xs"
                              >
                                📮 {order.pincode}
                              </Box>
                            </Flex>
                          </Flex>
                        </Card>
                      ))}
                  </Box>
                </Flex>
              </ModalBody>

              <ModalFooter
                display={"flex"}
                w={"full"}
                gap={2}
                justifyContent={"center"}
              >
                <Button
                  colorScheme="green"
                  onClick={handleBulkAssignment}
                  isLoading={assignLoading}
                  loadingText="Assigning..."
                >
                  Assign {selectedOrders.length} Order
                  {selectedOrders.length > 1 ? "s" : ""}
                </Button>
                <Button
                  colorScheme="red"
                  onClick={() => {
                    setIsOpenAssign(false);
                    setAssignModalData({
                      dplist: "",
                      vehicle: "",
                      driver: "",
                      dplist_error: "",
                      vehicle_error: "",
                      driver_error: "",
                    });
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}
    </>
  );
};

export default Orders;
